import { Tooltip } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { WithStyles } from 'decorators/withStyles';
import React, { Component } from 'react';

interface IProps {
  tooltip: string;
  label: string;
  property?: any;
  classes?: any;
}
@WithStyles(() => ({
  chipActive: {
    color: '#009358',
    borderColor: '#009358',
    margin: '2px 4px',
    fontSize: ' 0.7rem'
  },
  chipInactive: {
    color: '#8E8E8E',
    bordderColor: '#8E8E8E',
    margin: '2px 4px',
    fontSize: ' 0.7rem'
  }
}))
export default class TagItem extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.state = { personalizationOpen: true, expanded: false };
  }

  render() {
    const { tooltip, label, property, classes } = this.props;
    if (!property) {
      return null;
    }

    const isActive = property?.active ?? true;

    return (
      <Tooltip key={tooltip} title={`${tooltip} ${isActive ? 'ativo' : 'inativo'}`}>
        <Chip className={isActive ? classes.chipActive : classes.chipInactive} label={label} variant="outlined" />
      </Tooltip>
    );
  }
}
